import { forwardRef, useImperativeHandle, useRef, useEffect } from 'react'
import { Turnstile } from '@marsidev/react-turnstile'

interface TurnstileWidgetProps {
  onSuccess: (token: string) => void
  onError?: (error: Error) => void
  onExpire?: () => void
  className?: string
}

export interface TurnstileWidgetRef {
  reset: () => void
}

const TurnstileWidget = forwardRef<TurnstileWidgetRef, TurnstileWidgetProps>(
  ({ onSuccess, onError, onExpire, className }, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Define proper type for Turnstile ref
    const turnstileRef = useRef<any>(null)
    const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY

    useImperativeHandle(ref, () => ({
      reset: () => {
        if (turnstileRef.current) {
          turnstileRef.current.reset()
        }
      }
    }))

    useEffect(() => {
      const currentRef = turnstileRef.current
      return () => {
        if (currentRef) {
          currentRef.reset()
        }
      }
    }, [])

    const handleSuccess = (token: string) => {
      onSuccess(token)
    }

    const handleError = (error: string) => {
      console.error('Turnstile error:', error)
      if (onError) {
        onError(new Error(error))
      }
    }

    const handleExpire = () => {
      console.warn('Turnstile token expired')
      if (onExpire) {
        onExpire()
      }
    }

    if (!siteKey) {
      console.warn('VITE_TURNSTILE_SITE_KEY not configured')
      return null
    }

    return (
      <div className={className}>
        <Turnstile
          ref={turnstileRef}
          siteKey={siteKey}
          onSuccess={handleSuccess}
          onError={handleError}
          onExpire={handleExpire}
          options={{
            theme: 'light',
            size: 'normal',
          }}
        />
      </div>
    )
  }
)

TurnstileWidget.displayName = 'TurnstileWidget'

export default TurnstileWidget
